export interface OperationDetailsRequestBody {
  merchant_id: string;
  operation_type: number;
  batch_id: string;
  chain_type: number;
  chain_id: number;
  total_operation: number;
  client_data: string;
  request_time: string;
  wallet_type: number;
  operations: Operation[];
  smart_account_type: number;
}

export interface ExactGetExecutionDetail {
  execution_type: ExecutionType;
  asset_name: string;
  decimals: number;
  amount: string;
  to_address: string;
  swap_path: string[];
  asset_name_pay: string;
  decimals_pay: number;
  amount_pay_max: string;
}

export interface ExactPayExecutionDetail {
  execution_type: ExecutionType;
  asset_name: string;
  decimals: number;
  amount: string;
  to_address: string;
  swap_path: string[];
  asset_name_get: string;
  decimals_get: number;
  amount_get_min: string;
}

export interface Operation {
  merchant_order_id: string;
  merchant_id: string;
  operation_seq: number;
  operation_type: number;
  batch_id: string;
  wallet_version: number;
  wallet_path: string;
  asset_name: string;
  amount: string;
  decimals: number;
  from_address: string;
  to_address: string;
  request_time: string;
  to_wallet_tag: null;
  to_wallet_type: number;
  to_wallet_version: number;
  to_wallet_path: null;
  invoker_address: null;
  invoker_wallet_version: null;
  invoker_wallet_path: null;
  wallet_type: number;
  from_owner_address: string;
  from_owner_wallet_version: number;
  from_owner_wallet_path: string;
  to_owner_address: string;
  to_owner_wallet_version: number;
  to_owner_wallet_path: string;
  execution_detail: ExactGetExecutionDetail | ExactPayExecutionDetail;
  multi_sig_raw_txs: MultiSigRawTx[];
}

export enum ExecutionType {
  ExactPay = 1,
  ExactGet = 2,
}

export interface MultiSigRawTx {
  batch_id: number;
  data: string;
  from: string;
  nonce: number;
  required_sig: number;
  signer_addresses: string[];
  to: string;
  tx_hash: string;
  value: number;
}
